import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  FORM_INFOS_SUCCESS,
  FORM_INFOS_REQUEST,
  CIVIL_DATA_UPLOAD_REQUEST,
  CIVIL_DATA_UPLOAD_SUCCESS,
  CIVIL_DATA_UPLOAD_ERROR,
  CIVIL_DATA_UPDATE_LOCAL,
  SALARY_SITUATION_UPLOAD_REQUEST,
  SALARY_SITUATION_UPLOAD_SUCCESS,
  SALARY_SITUATION_UPLOAD_ERROR,
  SALARY_SITUATION_UPDATE_LOCAL,
  FORM_INFOS_ERROR,
  WORK_CONTRACT_UPLOAD_REQUEST,
  WORK_CONTRACT_UPLOAD_SUCCESS,
  WORK_CONTRACT_UPLOAD_ERROR,
  WORK_CONTRACT_UPDATE_LOCAL,
  SPECIAL_SITUATIONS_UPLOAD_REQUEST,
  SPECIAL_SITUATIONS_UPLOAD_SUCCESS,
  SPECIAL_SITUATIONS_UPLOAD_ERROR,
  SPECIAL_SITUATIONS_UPDATE_LOCAL,
  DOCUMENTS_UPDATE_LOCAL,
  DOCUMENTS_UPLOAD_PROGRESS,
  DOCUMENTS_UPLOAD_ERROR,
  SUBMIT_FORM_SUCCESS,
  DOCUMENTS_UPLOAD_REQUEST,
  RESET_FORM_SUCCESS,
} from '../actions';

const getTypicalStoreStructure = (tabName) => ({
  uploadStatus: STATUS_NOT_REQUESTED,
  data: { values: {} },
  isValid: false,
  [`${tabName}Errors`]: {},
  error: '',
});

const getInitialState = () => ({
  status: STATUS_NOT_REQUESTED,
  submitStatus: STATUS_NOT_REQUESTED,
  civilData: getTypicalStoreStructure('civilData'),
  salarySituation: getTypicalStoreStructure('salarySituation'),
  workContract: getTypicalStoreStructure('workContract'),
  specialSituations: getTypicalStoreStructure('specialSituations'),
  documents: getTypicalStoreStructure('documents'),
});

/**
 * TODO
 * Divide reducer by form tabs
 */
export const employeeRegister = (state = getInitialState(), action) => {
  switch (action.type) {
    case FORM_INFOS_REQUEST:
      return { ...state, status: STATUS_LOADING };

    case FORM_INFOS_SUCCESS: {
      const payload = action.payload || {};
      const safeDocuments = payload.documents
        ? {
            uploadStatus:
              payload.documents.uploadStatus ||
              state.documents.uploadStatus ||
              STATUS_NOT_REQUESTED,
            data: {
              values:
                payload.documents.data?.values ||
                state.documents.data.values ||
                {},
              progress:
                payload.documents.data?.progress !== undefined
                  ? payload.documents.data.progress
                  : state.documents.data.progress || 0,
            },
            isValid:
              payload.documents.isValid !== undefined
                ? payload.documents.isValid
                : state.documents.isValid,
            documentsErrors:
              payload.documents.documentsErrors ||
              state.documents.documentsErrors ||
              {},
            error: payload.documents.error || state.documents.error || '',
          }
        : state.documents;

      return {
        ...state,
        status: STATUS_SUCCESS,
        submitStatus: STATUS_NOT_REQUESTED,
        ...payload,
        documents: safeDocuments,
      };
    }

    case FORM_INFOS_ERROR:
      return { ...state, status: STATUS_ERROR };

    case CIVIL_DATA_UPLOAD_REQUEST:
      return {
        ...state,
        civilData: { ...state.civilData, uploadStatus: STATUS_LOADING },
      };

    case CIVIL_DATA_UPLOAD_SUCCESS:
      return {
        ...state,
        civilData: { ...state.civilData, uploadStatus: STATUS_SUCCESS },
      };

    case CIVIL_DATA_UPLOAD_ERROR:
      return {
        ...state,
        civilData: {
          ...state.civilData,
          uploadStatus: STATUS_ERROR,
          error: action.payload.error.message || 'error',
        },
      };

    case CIVIL_DATA_UPDATE_LOCAL:
      return {
        ...state,
        civilData: {
          ...state.civilData,
          civilDataErrors: action.payload.civilDataErrors,
          data: {
            ...state.civilData.data,
            values: action.payload.values,
          },
        },
      };

    case SALARY_SITUATION_UPLOAD_REQUEST:
      return {
        ...state,
        salarySituation: {
          ...state.salarySituation,
          uploadStatus: STATUS_LOADING,
        },
      };

    case SALARY_SITUATION_UPLOAD_SUCCESS:
      return {
        ...state,
        salarySituation: {
          ...state.salarySituation,
          uploadStatus: STATUS_SUCCESS,
        },
      };

    case SALARY_SITUATION_UPLOAD_ERROR:
      return {
        ...state,
        salarySituation: {
          ...state.salarySituation,
          uploadStatus: STATUS_ERROR,
          error: action.payload.error.message || 'error',
        },
      };

    case SALARY_SITUATION_UPDATE_LOCAL:
      return {
        ...state,
        salarySituation: {
          ...state.salarySituation,
          salarySituationErrors: action.payload.salarySituationErrors,
          data: {
            ...state.salarySituation.data,
            values: action.payload.values,
          },
        },
      };

    case WORK_CONTRACT_UPLOAD_REQUEST:
      return {
        ...state,
        workContract: { ...state.workContract, uploadStatus: STATUS_LOADING },
      };

    case WORK_CONTRACT_UPLOAD_SUCCESS:
      return {
        ...state,
        workContract: { ...state.workContract, uploadStatus: STATUS_SUCCESS },
      };

    case WORK_CONTRACT_UPLOAD_ERROR:
      return {
        ...state,
        workContract: {
          ...state.workContract,
          uploadStatus: STATUS_ERROR,
          error: action.payload.error.message || 'error',
        },
      };

    case WORK_CONTRACT_UPDATE_LOCAL:
      return {
        ...state,
        workContract: {
          ...state.workContract,
          workContractErrors: action.payload.workContractErrors,
          data: {
            ...state.workContract.data,
            values: action.payload.values,
          },
          error: '',
        },
      };

    case SPECIAL_SITUATIONS_UPLOAD_REQUEST:
      return {
        ...state,
        specialSituations: {
          ...state.specialSituations,
          uploadStatus: STATUS_LOADING,
        },
      };

    case SPECIAL_SITUATIONS_UPLOAD_SUCCESS:
      return {
        ...state,
        specialSituations: {
          ...state.specialSituations,
          uploadStatus: STATUS_SUCCESS,
        },
      };

    case SPECIAL_SITUATIONS_UPLOAD_ERROR:
      return {
        ...state,
        specialSituations: {
          ...state.specialSituations,
          uploadStatus: STATUS_ERROR,
          error: action.payload.error.message || 'error',
        },
      };

    case SPECIAL_SITUATIONS_UPDATE_LOCAL:
      return {
        ...state,
        specialSituations: {
          ...state.specialSituations,
          specialSituationsErrors: action.payload.specialSituationsErrors,
          data: {
            ...state.specialSituations.data,
            values: action.payload.values,
          },
        },
      };

    case DOCUMENTS_UPLOAD_REQUEST:
      return {
        ...state,
        documents: { ...state.documents, uploadStatus: STATUS_LOADING },
      };

    case DOCUMENTS_UPDATE_LOCAL: {
      // eslint-disable-next-line no-unused-vars
      const { comment, ...restValues } = action.payload.values;
      return {
        ...state,
        documents: {
          ...state.documents,
          documentsErrors: action.payload.documentsErrors,
          data: {
            ...state.documents.data,
            values: restValues,
          },
        },
      };
    }

    case DOCUMENTS_UPLOAD_PROGRESS:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: { ...state.documents.data, progress: action.payload },
        },
      };

    case DOCUMENTS_UPLOAD_ERROR:
      return {
        ...state,
        documents: {
          ...state.documents,
          error: action.payload,
          data: { ...state.documents.data, progress: 0 },
        },
      };

    case SUBMIT_FORM_SUCCESS:
      return { ...getInitialState(), submitStatus: STATUS_SUCCESS };

    case RESET_FORM_SUCCESS:
      return getInitialState();

    default:
      return state;
  }
};
